import React from 'react'

import SvgLazada from '../assets/icons/app/Lazada'
import SvgShopee from '../assets/icons/app/Shopee'
import SvgWhatsApp from '../assets/icons/app/WhatsApp'
import SvgYoutube from '../assets/icons/app/Youtube'
import SvgZoom from '../assets/icons/app/Zoom'

export const mockAppAccesses = [
  {
    app: 'Youtube',
    icon: <SvgYoutube />,
    allowAccess: true
  },
  {
    app: 'Shopee',
    icon: <SvgShopee />,
    allowAccess: false
  },
  {
    app: 'Zoom',
    icon: <SvgZoom />,
    allowAccess: false
  },
  {
    app: 'Lazada',
    icon: <SvgLazada />,
    allowAccess: true
  },
  {
    app: 'WhatsApp',
    icon: <SvgWhatsApp />,
    allowAccess: false
  }
]
export const mockBundleUsage = {
  status: 'Activated',
  expenditure: 200,
  activatedSims: 18,
  remainingData: 100,
  remainingVoice: 300,
  remainingSms: 300
}

export const mockBundle = {
  _id: '000000000000000000000000',
  type: 'Circles One',
  sims: 20,
  price: 45,
  data: 500,
  voice: 1000,
  sms: 2000
}

export const mockTotalTeamBundle = {
  // Mock data for total team bundle
  status: 'Activated',
  expenditure: 200,
  activatedSims: 18,
  data: 5000000000000, // Use convertBytesToGB to convert to GB afterwards
  voice: 60000,
  sms: 5000
}

export const mockCalLabels = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July'
]

// TODO(sn): change color
export const mockChartData = {
  labels: mockCalLabels,
  datasets: [
    {
      label: 'Data',
      data: mockCalLabels.map(() => Math.random() * 1000),
      borderColor: 'rgb(255, 99, 132)',
      backgroundColor: 'rgba(255, 99, 132, 0.5)'
    },
    {
      label: 'Voice',
      data: mockCalLabels.map(() => Math.random() * 100),
      borderColor: 'rgb(53, 162, 235)',
      backgroundColor: 'rgba(53, 162, 235, 0.5)'
    },
    {
      label: 'SMS',
      data: mockCalLabels.map(() => Math.random() * 25),
      borderColor: 'rgb(53, 162, 235)',
      backgroundColor: 'rgba(53, 162, 235, 0.5)'
    }
  ]
}
